import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getDataAPI } from '../../../utils/fetchData';

const Container = styled.div`
  height: 100%;
`;

const SectionTitle = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  padding-top: 8px;
`;

export default function ReleasesModule() {
  const [releases, setReleases] = useState({ latest: [], upcoming: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReleases();
  }, []);

  const fetchReleases = async () => {
    try {
      const token = localStorage.getItem('dizeeToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await getDataAPI('user/catalog', JSON.parse(token));
      
      if (response?.data?.data) {
        const now = new Date();
        const items = response.data.data;
        
        const latest = items
          .filter(r => new Date(r.releaseDate) <= now)
          .slice(0, 2);
          
        const upcoming = items
          .filter(r => new Date(r.releaseDate) > now)
          .slice(0, 2);
        
        setReleases({ latest, upcoming });
      }
    } catch (error) {
      console.log('Could not fetch releases:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Stack>
        <SectionTitle>Latest</SectionTitle>
        <SectionTitle>Upcoming</SectionTitle>
      </Stack>
    </Container>
  );
}

